(() => {
  if (window.__customRevealBound) return;
  window.__customRevealBound = true;

  const bind = (root) => {
    if (root.dataset.bound === 'true') return;
    const compare = root.querySelector('.custom-reveal__compare');
    const range = root.querySelector('.custom-reveal__range');
    if (!compare || !range) return;
    root.dataset.bound = 'true';

    let value = Number(range.value) || 52;
    let dir = 1;
    let paused = false;
    let timer = 0;

    const set = (next) => {
      value = Math.min(92, Math.max(8, next));
      range.value = String(value);
      compare.style.setProperty('--compare', String(value));
    };

    const onInput = () => {
      paused = true;
      set(Number(range.value));
    };

    range.addEventListener('input', onInput);
    range.addEventListener('pointerdown', () => {
      paused = true;
    });
    range.addEventListener('pointerup', () => {
      window.setTimeout(() => {
        paused = false;
      }, 1800);
    });

    const play = () => {
      if (!paused) {
        value += dir * 0.22;
        if (value >= 74) dir = -1;
        if (value <= 46) dir = 1;
        set(value);
      }
      timer = requestAnimationFrame(play);
    };

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !timer) play();
        });
      },
      { threshold: 0.25 }
    );
    io.observe(root);
  };

  const init = () => {
    document.querySelectorAll('[data-custom-reveal]').forEach(bind);
  };

  init();
  document.addEventListener('shopify:section:load', init);
})();
